<template>
  <v-dialog name="asd" v-model="modalComputed" persistent scrollable  max-width="800" v-if="filialComputed !== undefined">
    <v-card>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Prazos para magamentos - Empresa {{filialComputed.cc_fil}}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col>

              <div v-if="itens.length === 0">
                <v-alert text type="info" color="primary">N&atilde;o h&aacute; prazos cadastrados para esta empresa</v-alert>
              </div>

              <v-simple-table class="mb-2" v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="60">Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td><v-chip color="primary">{{ item.cc_prz }}</v-chip></td>
                      <td>{{ item.ds_prz }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div>
                <div>
                  <v-btn depressed outlined color="primary"  @click="inserir()">INSERIR</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  
  name: 'Prazo',
  
  props: {

    filial: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  data() {
    return {

      itens:[],

      prazo: {
        qt_prz: undefined
      },

      modalTemp : false,
      filialTemp: undefined

    }
  },

  methods: {

     listar() {
      this.itens = []
      if(this.filialComputed !== undefined) {
        this.$store.dispatch('pesquisaPrazo', {size:9999, cc_fil: this.filialComputed.cc_fil}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {

      let dados = undefined

      if (this.itens.length === 0) {

        dados = {
          cc_fil: this.filialTemp.cc_fil,
          cc_prz: `1X`,
          ds_prz: `Prazo 1X`,
          qt_prz: 1,
          qt_prz_med: 30,
        }

      } else {

        let qt_przs = []
        this.itens.forEach((el) => {
          qt_przs.push(el.qt_prz)
        })

        let qt_prz = Math.max(...qt_przs) + 1

        dados = {
          cc_fil: this.filialTemp.cc_fil,
          cc_prz: `${qt_prz}X`,
          ds_prz: `Prazo ${qt_prz}X`,
          qt_prz: qt_prz,
          qt_prz_med: 30,
        }

      }

      if(dados !== undefined) {

        this.$store.dispatch('salvarPrazo', dados).then(() => {
          this.listar()
        }).catch()

      }
    }

  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialComputed: {
      get: function() { 
        return this.filialTemp
      },
      set: function(value) {
        this.filialTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {
    
    this.modalComputed = this.modal
    this.filialComputed = this.filial
    this.$emit('a')

  }

}
</script>